<template>
    <div class="examTest">
        <div class="jobMain">
            <div class="examTest-m">
                <div class="examTest-mt clearfix">
                    <div class="examTest-mtl">
                        <div class="examTest-tle"><i class="el-icon-edit" style="color: #E7000B;"></i> 笔试练习维护</div>
                        <div class="examTest-subtle">维护模拟练习页面的富文本内容和考试地址</div>
                    </div>
                    <div class="examTest-mtr">
                        <el-button type="danger" round @click="editFun()"><i class="el-icon-edit"></i> 编辑内容</el-button>
                    </div>
                </div>
                <div class="examTest-mm" v-if="!editFlag">
                    <div class="examTest-mm-t">当前显示内容预览</div>
                    <div class="examTest-mm-content ql-editor" v-html="showObj ? showObj.content : ''"></div>
                    <div class="examTest-mm-t">考试地址</div>
                    <div class="examTest-mm-b">
                        <div class="examTest-mlink"><i class="el-icon-position"></i> <a :href="showObj ? showObj.url : ''" target="_blank">{{showObj ? showObj.url : ''}}</a></div>
                    </div>
                    <div class="examTest-mb">最后更新时间：{{ showObj ? showObj.createTime : '' }}</div>
                </div>
                <div class="examTest-mm" v-if="editFlag">
                    <div class="examTest-mm-t">当前显示内容预览</div>
                    <div>
                        <quill-editor
                            ref="myQuillEditor"
                            v-model="saveObj.content"
                            :options="editorOptions"
                        />
                    </div>
                    <div class="examTest-mm-t">考试地址</div>
                    <div class="examTest-mm-b">
                        <el-input v-model="saveObj.url" style="width: 100%;"></el-input>
                    </div>
                    <div class="examTest-mb">
                        <el-button type="danger" @click="saveEdit"><i class="el-icon-document-checked"></i> 保存更改</el-button>
                        <el-button @click="cannelEdit">取消</el-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Cookies from "js-cookie";
import axios from "axios";
import { quillEditor } from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import moment from "moment";

export default {
    name: 'PageExamTest',
    components: { quillEditor },
    data() {
        return {
            editFlag: false,
            showObj: null,
            editorOptions: {
                theme: 'snow',
                modules: {
                    toolbar: [
                        ['bold','italic','underline','strike'],
                        ['blockquote','code-block'],
                        [{header:1},{header:2}],
                        [{list:'ordered'},{list:'bullet'}],
                        [{script:'sub'},{script:'super'}],
                        [{indent:'-1'},{indent:'+1'}],
                        [{direction:'rtl'}],
                        [{size:['small',false,'large','huge']}],
                        [{header:[1,2,3,4,5,6,false]}],
                        [{color:[]},{background:[]}],
                        [{font:[]}],
                        [{align:[]}],
                        ['clean'],
                        ['link','image','video']
                    ]
                }
            },
            saveObj: {
                title: '',
                summary: '',
                brief: '',
                url: 'https://syqy170.qianuni.com/study/info/login?path=%2Fhome',
                content: '请输入您要编辑的内容',
                type: 0
            }
        }
    },
    mounted() {
        document.title = '潞安招聘-笔试练习';
        this.getNotice();
    },
    methods: {
        editFun: function () {
            this.editFlag = true;
        },
        cannelEdit: function () {
            this.editFlag = false;
        },
        saveEdit: function () {
            axios.post('/zhaopinapi/announcement/insert', this.saveObj,{
                headers: {'Authorization': Cookies.get('reqToKen')}
            }).then((res) => {
                let _d = res.data;
                if(_d.success) {
                    this.$message.success('更新成功！');
                    this.editFlag = false;
                    this.getNotice();
                } else {
                    this.$message.success(_d.message);
                    return false;
                }
            }).catch((error) => {
                console.log(error)
            })
        },
        getNotice: function () {
            if(Cookies.get('reqToKen')) {
                axios.get('/zhaopinapi/announcement/find-latest-by-type/0', {
                    headers: {'Authorization': Cookies.get('reqToKen')},
                }).then((res) => {
                    let _d = res.data;
                    if(_d.success) {
                        // console.log(_d)
                        _d.data.createTime = moment(_d.data.createTime).format('yyyy-MM-DD hh:mm:ss');
                        this.showObj = _d.data;
                        this.saveObj.content = _d.data.content;
                        this.saveObj.url = _d.data.url;
                    } else {
                        this.$message.error(_d.message);
                    }
                }).catch((error) => {
                    console.log(error)
                })
            }
        }
    }
}
</script>

<style scoped>
    .examTest{padding: 40px 0 100px 0;}
    .examTest-m{border-radius: 10px; border: 1px solid #F3F4F6; background: #fff;}
    .jobMain{width: 80%; max-width: 1400px; margin: 0 auto;}
    @media (max-width: 1400px) and (min-width: 1300px) {
        .jobMain{width: 90%;  margin: 0 auto;}
    }
    @media (max-width: 1300px) {
        .jobMain{width: 100%; min-width: 1150px;}
    }
    .examTest-mt{padding: 16px 24px; border-bottom: 1px solid #D1D5DC;}
    .examTest-mtl{float: left;}
    .examTest-mtr{float: right;}
    .examTest-tle{font-size: 18px; font-weight: bold; line-height: 30px; color: #3E3E3E;}
    .examTest-subtle{font-size: 14px; line-height: 20px; color: #99A1AF;}
    .examTest-mm{padding: 30px;}
    .examTest-mm-t{font-size: 16px; line-height: 30px; padding-bottom: 10px;}
    .examTest-mm-b{padding: 10px 0;}
    .examTest-mlink{padding: 16px; border-radius: 10px; border: 1px solid #c0dbfe; background: #eff6fe; color: #2a5cf9;}
    .examTest-mlink a{color: #2a5cf9; text-decoration: none;}
    .examTest-mb{border-top: 1px solid #D1D5DC; padding: 10px 0 0 0 ; line-height: 30px; color: #99A1AF;}
    .examTest-mm-content{background: #f9fafb; border-radius: 10px; border: 1px solid #e5e7eb; padding: 24px; margin-bottom: 16px;}
    /deep/ .quill-editor .ql-container .ql-editor {height: 300px !important;}

    .clearfix:after,.clearfix:before{
        clear: both;
        content: "";
        display: block;
        line-height: 0;
    }
</style>
